import { Select } from "@/shared/widgets/select";
import { useTranslation } from "@/shared/i18n";

interface PackSortProps {
  value: string;
  onChange: (value: string) => void;
}

export const PackSort = ({ value, onChange }: PackSortProps) => {
  const { t } = useTranslation('packs');
  
  return (
    <Select data={[
      { value: "name", label: t('sortByName') },
      { value: "status", label: t('sortByStatus') },
      { value: "creator", label: t('sortByCreator') },
      { value: "newest", label: t('sortByNewest') },
      { value: "oldest", label: t('sortByOldest') },
    ]} value={value} onChange={(e) => onChange(e)} />

  );
};
